import React, { useEffect, useRef } from 'react'
import {
  Container,
  Div,
} from '@/styled/common/loading'
import LoadingAnimation from '@/components/LoadingAnimation'

const WAITED_TOO_LONG_TIMEOUT = 15000

interface LoadingProps {
  shouldThrowError?: boolean
  className?: string
  style?: React.CSSProperties
  fixed?: boolean
  message?: string
}

const Loading = (props: LoadingProps) => {
  const waitedTooLongTimeout = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  useEffect(() => {
    waitedTooLongTimeout.current = setTimeout(() => {
      if (props.shouldThrowError) {
        throw new Error('Waited too long.')
      }
    }, WAITED_TOO_LONG_TIMEOUT)

    return () => {
      clearTimeout(waitedTooLongTimeout.current)
    }
  }, [])

  return (
    <Container
      className={props.className || 'Loading'}
      style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, ...(props.style || {})}}
      fixed={props.fixed}
    >
      <LoadingAnimation />

      {props.message && (
        <Div>
          {props.message}
        </Div>
      )}
    </Container>
  )
}

export default Loading
